import React, { Component } from "react";
import { Modal, ModalBody, ModalHeader, Button, Table } from "reactstrap";
// import { Formik } from "formik";
import axiosInstance from "../../axios-project";

class StateModal extends Component {
    constructor(props) {
        super(props);
        this.stateList = null;
        if (props.curr_user) {
            this.stateList = props.curr_user.states.map(s => s.state_id);
        }
        this.state = {
            allStates: []
        }
    }

    componentDidMount(prevProps, prevState, snapshot) {
        axiosInstance
            .get("/state")
            .then(response => {
                this.setState(prevState => {
                    return {
                        allStates: response.data
                    };
                });
            })
            .catch(error => {
                console.log(error);
            });
    }

    componentWillReceiveProps(nextProps, nextContext) {
        if (this.stateList === null && nextProps.curr_user) {
            this.stateList = nextProps.curr_user.states.map(s => s.state_id);
        }
    }

    addState = () => {
        this.stateList.push(null);
        this.forceUpdate();
    }

    removeState = index => {
        this.stateList.splice(index, 1);
        this.forceUpdate();
    }

    handleChange = (e, index) => {
        this.stateList[index] = parseInt(e.target.value);
        this.forceUpdate();
    }

    handleSubmit = e => {
        e.preventDefault();
        let stateString = this.stateList.join(",");
        if (stateString === "") {
            return;
        }
        console.log("/user/" + this.props.currentUserID + "/updatestate/" + stateString);
        axiosInstance
            .post("/user/" + this.props.currentUserID + "/updatestate/" + stateString)
            .then(response => {
                console.log("Success");
                this.stateList = null;
                this.props.fetchAdminDetails();
                this.forceUpdate();
            })
            .catch(error => {
                console.log(error);
            });
    };

    render() {
        return (
            <Modal
                id="stateModal"
                isOpen={this.props.modal}
                fade
                toggle={() => {
                    this.stateList = null;
                    this.props.toggle();
                }}
                backdrop="static"
            >
                <div className="modal-content">
                    <ModalHeader toggle={() => {
                        this.stateList = null;
                        this.props.toggle();
                    }}>
                        Change User's States
                    </ModalHeader>
                    <ModalBody>
                        <form
                            className="form"
                            id="userStateForm"
                            name="userStateForm"
                            onSubmit={this.handleSubmit}
                        >
                            {/* <small className={"d-block"}>
                <span style={{ color: "red" }}>*</span> required
              </small> */}

                            <Table borderless striped>
                                <thead className="border-bottom">
                                <tr>
                                    <th> State </th>
                                    <th> Action </th>
                                </tr>
                                </thead>
                                <tbody>
                                {this.stateList ? this.stateList.map((state, index) => (
                                    <tr>
                                        <td key={"state_select_" + index}>
                                            <select
                                                type="select"
                                                className="form-control form-control-sm"
                                                name={"state_id_" + index}
                                                id={"state_id_" + index}
                                                value={this.stateList[index]}
                                                onChange={e => this.handleChange(e, index)}
                                            >
                                                <option key={"default"} value={"default"} disabled>
                                                    --select one--
                                                </option>
                                                {this.state.allStates.map(option => (
                                                    <option key={option.state_id} value={option.state_id}>
                                                        {option.state_name}
                                                    </option>
                                                ))}
                                            </select>
                                        </td>
                                        <td key={"state_remove_" + index}>
                                            <Button
                                                color="danger"
                                                type="button"
                                                size="sm"
                                                block
                                                onClick={() => this.removeState(index)}
                                            >
                                                Remove
                                            </Button>
                                        </td>
                                    </tr>
                                )) : null}
                                <tr>
                                    <td colSpan="2">
                                        <Button
                                            color="primary"
                                            type="button"
                                            block
                                            onClick={this.addState}
                                        >
                                            Add State
                                        </Button>
                                    </td>
                                </tr>
                                </tbody>
                            </Table>

                            <div className="form-group my-3">
                                <Button
                                    color="primary"
                                    type="submit"
                                    className="float-left mx-2"
                                    onClick={this.props.toggle}
                                >
                                    Submit
                                </Button>
                                <Button
                                    color="secondary"
                                    type="button"
                                    className="float-left"
                                    onClick={() => {
                                        this.stateList = null;
                                        this.props.toggle();
                                    }}
                                >
                                    Cancel
                                </Button>
                            </div>
                        </form>
                    </ModalBody>
                </div>
            </Modal>
        );
    }
}

export default StateModal;
